import { emptyMongoApi } from "../../services/emptyMongoApi";
import apiCall from "./apiCall";

const moduleAPI = emptyMongoApi.injectEndpoints({
    endpoints: (builder) => ({
        getReminderComments: builder.query({
            queryFn: async ({ itemId = null, moduleId = null }) => {
                try {
                    if (!moduleId || !itemId) {
                        return { data: [] };
                    }

                    const result = await apiCall.get("GetReminderComments", { params: { itemId, moduleId } });

                    return { data: result.data || [] };
                } catch (error) {
                    console.error(error);
                    return { error };
                }
            },
            keepUnusedDataFor: 0,
        }),
    }),
});

export const { useGetReminderCommentsQuery } = moduleAPI;
